Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.NavbarView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/navbar']
  className: 'top-nav-bar clearfix d-flex w-100'

  initialize: ({session, chartListItemCollectionViewFactory, lastUpdatedDate}) ->
    @session = session
    @chartListItemCollectionViewFactory = chartListItemCollectionViewFactory
    @lastUpdatedDate = lastUpdatedDate
    @lastUpdatedView = new Common.Dashboard.Charts.LastUpdatedDateView(lastUpdatedDate: @lastUpdatedDate)
    @refreshInterval = new Common.Dashboard.RefreshIntervalModel(
      selectedOption: @session.get('refresh_interval_in_seconds')
    )
    @listenTo(@refreshInterval, 'change', =>
      @session.save refresh_interval_in_seconds: @refreshInterval.get('selectedOption')
    )
    @refreshIntervalPickerView = new Common.Dashboard.Charts.RefreshIntervalPickerView(
      refreshInterval: @refreshInterval
      chosen: true
      width: '234px'
    )
    @listenTo(@session.getWidgetCollection(), 'update', @renderChartList)
    @listenTo(@session.getWidgetCollection(), 'session:execution', @renderChartList)
    @listenTo(@session, 'session:filterChange', @onSessionExecution)
    @listenTo(@session, 'session:execution:finished', @onSessionExecution)
    @listenTo @session, 'session:execution:pending', =>
      @$el.addClass('automatic-refresh-loading')

  render: ->
    @$el.html @template
    @renderChartList()
    @renderRefreshIntervalPicker()
    @renderLastUpdatedDate()
    @$('#session-sharing-button-container').html(@_sharingButton().render().el)
    @

  renderChartList: ->
    items = @chartListItemCollectionViewFactory.create(@session)
    chartList = @$el.find('#graph-list')
    chartList.empty()
    items.forEach((item) -> chartList.append(item.render().el))

  renderRefreshIntervalPicker: ->
    @$el.find('.refresh-interval-container').html(@refreshIntervalPickerView.render().el)

  renderLastUpdatedDate: ->
    @lastUpdatedView.setLastUpdatedDate(@lastUpdatedDate)
    @$('.last-updated-container').html(@lastUpdatedView.render().el)

  _sharingButton: ->
    new Common.Sessions.SharingButton
      session: @session

  onSessionExecution: =>
    @renderChartList()
    @modifyLastUpdated()
    @$el.removeClass('automatic-refresh-loading')
    @renderLastUpdatedDate()

  modifyLastUpdated: ->
    @lastUpdatedDate = moment().format('HH:mm - DD/MM/YYYY')
